import { Padding } from "../../styles/CommonStyles";
import {
  TableWrapper,
  Row,
  Column,
  Flex,
  FirstPart,
  Favorite,
} from "../../styles/PairBoxStyles";
import { formatNumber } from "../../utils/common"
import { useMainContext } from "../../contexts/main"
import {Fragment} from "react";


const PairTable = ({ pairs, onStarredChange }) => {

  const { setMarket } = useMainContext()

  const onPairClicked = (pair) => {
    setMarket({ coin: pair.coin, pair: pair.pair })
  }


  return (
    <Padding padding="10px 0 10px 10px">
      <TableWrapper data-tut="tour_select_market">
        {pairs?.map((pair, index) => (
            <Fragment key={index}>
              {pair?.pair && (
                  <Row key={pair.price}>
                    <Column index={0}>
                      <Flex>
                        <Favorite
                            onClick={() => onStarredChange(pair)}
                            active={pair.starred}
                        />
                        <Flex onClick={() => onPairClicked(pair)}>
                          <FirstPart>{pair?.coin?.toUpperCase()}</FirstPart>/
                          {pair?.pair?.toUpperCase()}
                        </Flex>
                      </Flex>
                    </Column>
                    <Column index={1} definedColor={pair.color}>
                      {formatNumber(pair.price)}
                    </Column>
                    <Column
                        index={2}
                        definedColor={pair._24change > 0 ? "#33c07b" : pair._24change < 0 ? "#f84960" : null}
                    >
                      {
                        !pair._24change ?
                          '-'
                            :
                            parseFloat(pair._24change).toFixed(2)
                      }
                    </Column>
                  </Row>
              )}
            </Fragment>
        ))}
      </TableWrapper>
    </Padding>
  );
};


export default PairTable;
